// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectVersionWrapper {
  position: relative;
  display: flex;
  float: right;
  z-index: 10;
  margin-top: 16px;
  margin-right: 16px;
}
.selectVersionWrapper .selectVersionContainer {
  font-size: 16px;
  font-weight: 500;
  height: 32px;
  padding: 4px 15px;
  cursor: pointer;
  background-color: #f3f4f5;
  border-radius: 8px 0px 0px 8px;
  display: flex;
  margin-right: 2px;
}
.selectVersionWrapper .selectVersionContainer .selectVersionTitle {
  font-size: 14px;
  margin: auto;
  color: #1b1c1e;
}
.selectVersionWrapper .dropDownIcon {
  height: 32px;
  width: 40px;
  cursor: pointer;
  background-color: #f3f4f5;
  border-radius: 0px 8px 8px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.selectVersionWrapper .dropDownWrapper {
  width: 100%;
  position: absolute;
  z-index: 18;
  top: 36px;
  left: 0px;
  will-change: transform;
}
.selectVersionWrapper .dropDownWrapper .dropDownContainer {
  overflow-y: auto;
  background-color: white;
  border-radius: 8px;
}
.selectVersionWrapper .dropDownWrapper .dropDownContainer .dropDown {
  margin: 0;
  position: relative;
  list-style: none;
  padding: 8px 0px;
}
.selectVersionWrapper .dropDownWrapper .dropDownContainer .dropDown .dropDownItem {
  font-size: 14px;
  font-weight: 500;
  color: #1b1c1e;
  min-height: auto;
  width: auto;
  overflow: hidden;
  line-height: 1.5;
  white-space: nowrap;
  letter-spacing: 0.00938em;
  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  display: flex;
  position: relative;
  box-sizing: border-box;
  text-align: left;
  align-items: center;
  justify-content: flex-start;
  text-decoration: none;
  cursor: pointer;
  padding: 0px 16px;
}
.selectVersionWrapper .dropDownWrapper .dropDownContainer .dropDown .dropDownItem:hover {
  text-decoration: none;
  background-color: rgba(0, 0, 0, 0.04);
}
.selectVersionWrapper .dropDownWrapper .dropDownContainer .dropDown .dropDownItem span {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  overflow: hidden;
  position: absolute;
  border-radius: inherit;
  pointer-events: none;
}
.versionPopover .ant-popover-content {
  top: -28px;
  right: 18px;
}
`, "",{"version":3,"sources":["webpack://./src/View/Option/Components/SelectVersion/index.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AACF;AAPA;EASI,eAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,8BAAA;EACA,aAAA;EACA,iBAAA;AACJ;AAlBA;EAoBM,eAAA;EACA,YAAA;EACA,cAAA;AACN;AAvBA;EA2BI,YAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AADJ;AAjCA;EAsCI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;EACA,sBAAA;AAFJ;AAzCA;EA+CM,gBAAA;EACA,uBAAA;EACA,kBAAA;AAHN;AA9CA;EAoDQ,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAHR;AApDA;EA0DU,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EAEA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mEAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,2BAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;AAJV;AAKU;EACE,qBAAA;EACA,qCAAA;AAHZ;AA7EA;EAoFY,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,oBAAA;AAJZ;AAaA;EAEI,UAAA;EACA,WAAA;AAZJ","sourcesContent":[".selectVersionWrapper {\n  position: relative;\n  display: flex;\n  float: right;\n  z-index: 10;\n  margin-top: 16px;\n  margin-right: 16px;\n\n  .selectVersionContainer {\n    font-size: 16px;\n    font-weight: 500;\n    height: 32px;\n    padding: 4px 15px;\n    cursor: pointer;\n    background-color: #f3f4f5;\n    border-radius: 8px 0px 0px 8px;\n    display: flex;\n    margin-right: 2px;\n\n    .selectVersionTitle {\n      font-size: 14px;\n      margin: auto;\n      color: rgb(27, 28, 30);\n    }\n  }\n\n  .dropDownIcon {\n    height: 32px;\n    width: 40px;\n    cursor: pointer;\n    background-color: #f3f4f5;\n    border-radius: 0px 8px 8px 0px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .dropDownWrapper {\n    width: 100%;\n    position: absolute;\n    z-index: 18;\n    top: 36px;\n    left: 0px;\n    will-change: transform;\n\n\n    .dropDownContainer {\n      overflow-y: auto;\n      background-color: white;\n      border-radius: 8px;\n\n      .dropDown {\n        margin: 0;\n        position: relative;\n        list-style: none;\n        padding: 8px 0px;\n\n        .dropDownItem {\n          font-size: 14px;\n          font-weight: 500;\n          color: rgb(27, 28, 30);\n          min-height: auto;\n          width: auto;\n          overflow: hidden;\n          box-sizing: border-box;\n          line-height: 1.5;\n          white-space: nowrap;\n          letter-spacing: 0.00938em;\n          transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n          display: flex;\n          position: relative;\n          box-sizing: border-box;\n          text-align: left;\n          align-items: center;\n          justify-content: flex-start;\n          text-decoration: none;\n          cursor: pointer;\n          padding: 0px 16px;\n          &:hover {\n            text-decoration: none;\n            background-color: rgba(0, 0, 0, 0.04);\n          }\n\n          span {\n            top: 0;\n            left: 0;\n            right: 0;\n            bottom: 0;\n            z-index: 0;\n            overflow: hidden;\n            position: absolute;\n            border-radius: inherit;\n            pointer-events: none;\n          }\n        }\n      }\n    }\n  }\n\n}\n\n.versionPopover {\n  .ant-popover-content {\n    top: -28px;\n    right: 18px;\n  }\n}\n\n\n\n\n\n@primary-color: black;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
